import { ExpandLess, ExpandMore, Lightbulb } from "@mui/icons-material"
import { ButtonBase, Collapse } from "@mui/material"
import { useCallback, useState } from "react"
import SuggestedPrompts from "../no-message/suggested-prompts"

export default function SuggestedPromptsCollapsible() {
  const [isOpen, setIsOpen] = useState(false)

  const handleToggle = useCallback(() => {
    setIsOpen((prev) => !prev)
  }, [])

  const handlePromptSelected = useCallback(() => {
    setIsOpen(false)
  }, [])

  return (
    <div className="suggested-prompts-collapsible">
      <ButtonBase className="suggested-prompts-collapsible-toggle" onClick={handleToggle}>
        <Lightbulb fontSize="small" />
        <span>Suggestions</span>
        {isOpen ? <ExpandLess fontSize="small" /> : <ExpandMore fontSize="small" />}
      </ButtonBase>
      <Collapse in={isOpen} unmountOnExit>
        <SuggestedPrompts onPromptSelected={handlePromptSelected} surface="collapsed" />
      </Collapse>
    </div>
  )
}
